module.exports = __webpack_public_path__ + "static/img/new.38359934.gif";